import { Divider } from '@chakra-ui/layout';
import { FC } from 'react';
import { CbStarEntitySkeleton } from '../CbStarEntity';
export interface CbRecognitionStarListSkeletonProps {
  numberToRender: number;
}
export const CbRecognitionStarListSkeleton: FC<CbRecognitionStarListSkeletonProps> = ({
  numberToRender
}) => {
  const array = Array.from(Array(numberToRender).keys());
  return <>
        {array.map((entity, i) => <>
            <CbStarEntitySkeleton key={entity} minHeight={{
        md: '70px'
      }} />
            {i !== array.length - 1 && <Divider marginY={3} />}
          </>)}
      </>;
};